import axios from '../axios';

export default {
  getSipHistory: (id) => axios.get(`/gate/${id}/sip-status-logs`),
  newGate (gate) {
    return new Promise((resolve, reject) => {
      axios.post('/gate', gate)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  massAddGateDoorphones (gateId, { doorphone_ids, apartment_prefixes, without_apartment_prefix }) {
    return new Promise((resolve, reject) => {
      axios.post(`/gate/${gateId}/doorphones/mass`, { doorphone_ids, apartment_prefixes, without_apartment_prefix })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  addGateDoorphone (gate, doorphone, { apartment_prefix, without_apartment_prefix }) {
    return new Promise((resolve, reject) => {
      axios.post(`/gate/${gate}/doorphone/${doorphone}`, { apartment_prefix, without_apartment_prefix })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteGateDoorphone (gate, doorphone) {
    return new Promise((resolve, reject) => {
      axios.delete(`/gate/${gate}/doorphone/${doorphone}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getWebInfoGate (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/web/gate/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  exportSipHistoryCsvGate (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/gate/${id}/sip-status-logs/export-csv`, { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  loadAllGates (options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/gate?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  newGateStore (gate) {
    return new Promise((resolve, reject) => {
      axios.post('/gate/store', gate)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateGate (id, params) {
    return new Promise((resolve, reject) => {
      axios.put(`/gate/${id}`, params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getGateInfoEdit (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/gate/${id}/edit`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  openGate (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/gate/${id}/open`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getSipStatus: (id) => axios.put(`/gate/${id}/status`),

  createKeyGate (id, gate) {
    return new Promise((resolve, reject) => {
      axios.post(`/gate/${id}/key`, gate)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  importKeysFromDevice (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/gate/${id}/key/import`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  exportKeysToDevice (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/gate/${id}/key/export`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getImportKeysGate (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/gate/${id}/import-keys`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getDestroyKeysGate (id, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/gate/${id}/key/destroy-by-csv`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  removeGate (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/gate/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  removeKeyGate (id, keyId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/gate/${id}/key/${keyId}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  detachKeyGate (id, keyId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/gate/${id}/key/${keyId}/detach`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
